import { useAppStore } from '@/store/useAppStore.ts'
import { getChemistryPreset } from '@brt/shared-logic'
import { ExpressionInput } from 'calc-controls'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'

export default function CutoffVoltageInput() {
  const cutoffVoltage = useAppStore((s) => s.battery.cutoffVoltage)
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const voltage = useAppStore((s) => s.battery.voltage)
  const dod = useAppStore((s) => s.battery.dod)
  const updateBattery = useAppStore((s) => s.updateBattery)

  const preset = getChemistryPreset(chemistry)
  const defaultCutoff = preset.cutoffVoltage

  const cellsInSeries = Math.max(1, Math.round(voltage / preset.nominalCellVoltage))
  const effectiveMinVoltage = cutoffVoltage * cellsInSeries
  const dodCutoffVoltage = voltage * (1 - dod)

  const isBelowCutoff = dodCutoffVoltage < effectiveMinVoltage && chemistry !== 'CUSTOM'
  const isChanged = cutoffVoltage !== defaultCutoff

  return (
    <div className="cutoff-voltage-input">
      <HelpIcon text="Per-cell voltage at which the battery is considered fully discharged. Discharging below this threshold risks permanent cell damage.">
        <span className="cutoff-voltage-input__label">Cutoff Voltage (per cell)</span>
      </HelpIcon>
      <ExpressionInput
        label="Cutoff Voltage (per cell)"
        value={cutoffVoltage}
        onChange={(v) => {
          if (v >= 0) {
            updateBattery('cutoffVoltage', Math.round(v * 100) / 100)
          }
        }}
        unit="V"
        min={0}
        max={preset.nominalCellVoltage}
        decimals={2}
      />
      <div className="cutoff-voltage-input__meta">
        <span className="cutoff-voltage-input__default">
          Default: {defaultCutoff}V
        </span>
        {isChanged && (
          <span className="cutoff-voltage-input__custom">Custom</span>
        )}
      </div>
      {isBelowCutoff && (
        <p className="cutoff-voltage-input__warning" role="alert">
          DoD of {Math.round(dod * 100)}% pushes battery below cutoff voltage — reduce DoD or increase cutoff
        </p>
      )}
    </div>
  )
}
